import React from "react";
import { AlertNotification } from "@shared/models";
import { TableProperty } from "@shared/components/Table/interfaces";

import { AlertNotificationRowComponent } from "../components/DashboardHospitalContainer/AlertNotificationsCard/AlertNotificationRowComponent";

export const alertNotificationsTableProperties: TableProperty<AlertNotification>[] = [
  {
    key: "id",
    title: "",
    get: (item) => {
      return <AlertNotificationRowComponent item={item} />;
    },
  },
];
